/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_TitleInputs */

const en_vc_status_title = /** @type {(inputs: Vc_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where VectorCraft stands today`)
};

const zh_vc_status_title = /** @type {(inputs: Vc_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 目前的完成度`)
};

/**
* | output |
* | --- |
* | "Where VectorCraft stands today" |
*
* @param {Vc_Status_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_title = /** @type {((inputs?: Vc_Status_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_title(inputs)
	return zh_vc_status_title(inputs)
});
export { vc_status_title as "vc.status.title" }